
import React from "react";
import { Link } from "react-router-dom";
import { MENU } from "../enums/menu.enum";

export default function HomeLink() {
  return <Link to={MENU.home}>Home</Link>
}